"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordTile = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const utils_1 = require("../../utils");
const types_1 = require("../../gameplay/types");
function WordTile({ gameplayStyle, text, ...rest }) {
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
        react_1.default.createElement(material_1.Button, { variant: "outlined", size: "large", sx: {
                border: `1px solid ${getTextColor(gameplayStyle)}`,
                color: getTextColor(gameplayStyle),
                paddingX: '22px',
                paddingY: '8px',
                borderRadius: '12px',
                fontFamily: 'Effra',
                fontSize: '15px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '26px',
                letterSpacing: '0.46px',
                '&:focus': {
                    outline: 'none',
                    boxShadow: 'none',
                    borderColor: getTextColor(gameplayStyle),
                },
            }, ...rest }, text)));
}
exports.WordTile = WordTile;
function getTextColor(gameplayStyle) {
    const theme = (0, utils_1.getTheme)(gameplayStyle);
    switch (gameplayStyle) {
        case types_1.GameplayStyle.PopStudy:
            return theme.palette.primary.main;
        case types_1.GameplayStyle.PopQuiz:
        case types_1.GameplayStyle.PopQuizHost:
            return theme.palette.primary.contrastText;
    }
}
